export function SuccessBanner({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div className="px-4 py-3 bg-green-50 border-l-4 border-green-600 text-green-800 mb-4">
      {message}
    </div>
  );
}
